import { IProvidentStripePayment } from 'types';
import { AppActionTypes } from '../actions';
import { Types } from '../actions/provident-stripe-payment-actions';

const providentPaymentReducer = (
  state: IProvidentStripePayment,
  action: AppActionTypes,
): IProvidentStripePayment => {
  switch (action.type) {
    case Types.SET_PAYMENT_STATUS:
      return { ...state, paymentStatus: action.data };
    case Types.SET_SHOW_STRIPE:
      return { ...state, showStripe: action.data };
    case Types.SET_STRIPE_LOADING:
      return { ...state, stripeLoading: action.data };
    default:
      return state;
  }
};

export default providentPaymentReducer;
